
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertsCautionTwotone as ObiAlertsCautionTwotoneElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alerts-caution-twotone.js';
 
 
 

 
 export const ObiAlertsCautionTwotone = createComponent({
   react: React,
   tagName: 'obi-alerts-caution-twotone',
   elementClass: ObiAlertsCautionTwotoneElement,
   events: {
     
   }
  });
 
 